import { render, staticRenderFns } from "./BreadcrumbNav.vue?vue&type=template&id=3ca532f1&scoped=true&"
import script from "./BreadcrumbNav.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbNav.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbNav.vue?vue&type=style&index=0&id=3ca532f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca532f1",
  null
  
)

export default component.exports